// @ts-nocheck

import { find } from 'lodash'
import { Suspense, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { MixpanelEvents, sendMixpanelEvent } from '../../hooks/useMixpanelEvent'
import Field from '../fields'
import Modal from './index'
import PopupModal from './PopupModal'

interface DocumentModalProps {
  documentCategories?: any[]
  homeDocumentCategories?: any[]
  type?: 'create' | 'edit'
  fetchList: (id: string) => void
  fields: any
  files: any
  listId: string
  isOpen: boolean
  createItem: (args: any) => void
  updateItem: (args: any) => void
  showToast: (args: { title: string }) => void
  onComplete?: (document: any) => void
  features?: any
  user?: any
}

export function DocumentModal(props: DocumentModalProps) {
  const {
    documentCategories,
    fetchList,
    fields,
    files,
    homeDocumentCategories,
    isOpen,
    listId,
    type,
    createItem,
    updateItem,
    showToast,
    onComplete,
    features: home,
    user,
    ...formProps
  } = props

  const isMounted = useRef(false)
  const prevListId = useRef<string | undefined>(undefined)

  // biome-ignore lint/correctness/useExhaustiveDependencies: mirror legacy componentDidUpdate, fetch on listId change only
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      prevListId.current = listId
      return
    }
    if (!prevListId.current && listId) {
      fetchList(LIST_MAP[listId])
    }
    prevListId.current = listId
  }, [listId])

  const handleSubmit = () => {
    const url =
      type === 'edit' ? `list/${listId}/${fields.id}` : `list/${listId}`

    const chosenFunc = type === 'edit' ? updateItem : createItem
    chosenFunc({
      url,
      onComplete: (document) => {
        const toastTitle =
          type === 'edit' ? 'Updated a Document' : 'Added a Document'
        showToast({ title: toastTitle })
        fetchList(listId)
        if (files?.pdf?.file) {
          sendMixpanelEvent(
            MixpanelEvents.DOCUMENT_UPLOADED,
            {
              source:
                listId === 'home-documents'
                  ? 'organisation_documents'
                  : 'resident_documents',
              category: selectedCategory?.name ?? fields.category,
              categoryId: fields.category,
              subCategory: fields.subCategory,
              fileType: files.pdf.file.type,
              isAssignedToCarePlan: false
            },
            home,
            user
          )
        }
        onComplete?.(document)
      }
    })
  }

  const categories =
    listId === 'documents' ? documentCategories : homeDocumentCategories

  if (!isOpen || !type || !listId || !categories) {
    return null
  }

  // TODO: set subCategory to null if the category changes
  // Otherwise it'll presist
  const selectedCategory = find(categories, { id: fields.category })
  const subCatOptions =
    selectedCategory &&
    selectedCategory.subCategories &&
    selectedCategory.subCategories.map((name) => ({
      value: name,
      label: name
    }))

  return (
    <PopupModal
      confirmText={type === 'edit' ? 'Save' : 'Add'}
      buttonIcon={type !== 'edit' && 'PlusOutlined'}
      buttonColour="success"
      list={TITLE_MAP[listId]}
      includesRequired
      onConfirm={handleSubmit}
      style={{ overflow: 'visible' }}
      type={type}
      {...formProps}
    >
      <FieldContainer>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={MODAL_ID}
            keys="name"
            label="Document Title"
            required
            type="text"
            values={fields}
          />
        </Suspense>
      </FieldContainer>
      <FieldContainer>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={MODAL_ID}
            keys="category"
            label="Category"
            options={
              listId === 'documents'
                ? documentCategories
                : homeDocumentCategories
            }
            required
            type="select"
            values={fields}
          />
        </Suspense>
      </FieldContainer>
      {selectedCategory && selectedCategory.subCategories && (
        <FieldContainer>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="subCategory"
              label="Sub-category"
              // dependsOnKey="category"
              options={subCatOptions}
              type="select"
              values={fields}
            />
          </Suspense>
        </FieldContainer>
      )}
      <FieldContainer>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={MODAL_ID}
            keys="pdf"
            label="Document"
            required
            type="file"
            values={files}
          />
        </Suspense>
      </FieldContainer>
    </PopupModal>
  )
}

const MODAL_ID = 'documentModal'
const LIST_MAP = {
  documents: 'document-categories',
  'home-documents': 'home-document-categories'
}
const TITLE_MAP = {
  documents: 'Document',
  'home-documents': 'Home Document'
}

const mapStateToProps = (state) => ({
  documentCategories: state.data['document-categories'],
  homeDocumentCategories: state.data['home-document-categories']
})

const wrappedModal = connect(mapStateToProps, null)(DocumentModal)

export default Modal(wrappedModal, MODAL_ID)

const FieldContainer = styled.div`
  margin-bottom: 20px;

  @media (min-width: 650px) {
    min-width: 540px;
  }
`
